import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { Input } from "stories/forms";
import { useStoreState, useStoreActions } from 'easy-peasy';


const CurrencySelect = ({ label, name="currency", onChange,chose=true, value, ...rest }) => {
  const { t } = useTranslation();
  const companies = useStoreState((state) => state.companies?.companies)

  
  const getInputOptions = useCallback(() => {
    return companies && companies.map(obj => {
      return (
        <option value={obj.id}>{obj.name}</option>
      )
    })
  }, [companies])
  
  return (
    <Input  label={label || label === "" ? label : t("company_select_label", "Yritys")} type="select" name={name} onChange={onChange} value={value} {...rest}>
      {chose && <option value="" label={t("Valitse")}></option>}
      {getInputOptions()}
    </Input>
  )
  
  
}

export default CurrencySelect;